var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 790,
    height: 176,
    viewBox: "0 0 790 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M790 105C790 77.94 768.06 56 741 56C713.94 56 692 77.94 692 105C692 132.06 713.94 154 741 154C759.75 154 776.04 143.47 784.28 128C785.47 125.76 786.49 123.42 787.33 121H756.49C752.54 125.31 746.8 128 740.53 128C734.86 128 729.73 125.7 726.01 121.99C725.69 121.67 725.38 121.34 725.09 121C723.32 118.98 721.93 116.61 721.07 114H789.18C789.72 111.09 790 108.08 790 105ZM720.6 100C722.84 90.81 731.12 84 741 84C750.88 84 759.16 90.81 761.4 100H720.6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M408 105C408 77.94 386.06 56 359 56C331.94 56 310 77.94 310 105C310 132.06 331.94 154 359 154C377.75 154 394.04 143.47 402.28 128C403.47 125.76 404.49 123.42 405.33 121H374.49C370.54 125.31 364.8 128 358.53 128C352.86 128 347.73 125.7 344.01 121.99C343.69 121.67 343.38 121.34 343.09 121C341.32 118.98 339.93 116.61 339.07 114H407.18C407.72 111.09 408 108.08 408 105ZM338.6 100C340.84 90.81 349.12 84 359 84C368.88 84 377.16 90.81 379.4 100H338.6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 15C53.94 15 39.58 20.11 28 28.75V0H0V78H28.51C31.63 58.17 48.79 43 69.5 43C92.42 43 111 61.58 111 84.5C111 104.86 96.34 121.8 77 125.32V153.6C111.85 149.86 139 120.35 139 84.5C139 46.12 107.88 15 69.5 15Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M515 56C487.94 56 466 77.94 466 105C466 132.06 487.94 154 515 154C522.52 154 529.64 152.31 536 149.28V154H564V105C564 77.94 542.06 56 515 56ZM515 126C503.4 126 494 116.6 494 105C494 93.4 503.4 84 515 84C526.6 84 536 93.4 536 105C536 116.6 526.6 126 515 126Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M628 56C600.94 56 579 77.94 579 105V176H607V149.28C613.36 152.31 620.48 154 628 154C655.06 154 677 132.06 677 105C677 77.94 655.06 56 628 56ZM628 126C616.4 126 607 116.6 607 105C607 93.4 616.4 84 628 84C639.6 84 649 93.4 649 105C649 116.6 639.6 126 628 126Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M267 105C267 116.6 257.6 126 246 126C234.4 126 225 116.6 225 105V56H197V105C197 132.06 218.94 154 246 154C273.06 154 295 132.06 295 105V56H267V105Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M182 0H154V154H182V0Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M504 0H370V28H423V154H451V28H482L504 0Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M479 5L482 28L504 0L479 5Z",
    fill: "#5CC0FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6804 92H0.400391C3.91039 124.72 30.1404 150.65 63.0004 153.69V125.49C45.6204 122.76 31.8204 109.24 28.6804 92Z",
    fill: "#5CC0FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7af4cfee.svg";
export { ForwardRef as ReactComponent };